module.exports = __webpack_public_path__ + "static/media/welcome_page_logo.1f7c13de.png";